import { useOutletContext } from 'react-router-dom'
import type { Agent } from '@/types'
import { Card } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'

export function AgentPromptTab() {
  const { agent } = useOutletContext<{ agent: Agent }>()

  if (!agent.system_prompt) {
    return (
      <EmptyState
        title="Sin system_prompt compilado"
        hint="Andá a la tab Identity y compilá soul + role."
      />
    )
  }

  return (
    <Card>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>system_prompt compilado</div>
        <div className="mono" style={{ fontSize: 12 }}>v{agent.prompt_version}</div>
      </div>
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          fontFamily: 'var(--font-mono)',
          fontSize: 13,
          color: 'var(--text-primary)',
          margin: 0,
        }}
      >
        {agent.system_prompt}
      </pre>
    </Card>
  )
}
